import React from 'react'
import { Link } from 'react-router-dom'; 
import { useState } from 'react';
import "./nepaltour.css"
import "./guide.css"
import "./rental.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp, faChevronDown,faCheckCircle, faChevronUp,faVideo, faLanguage,faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
const Rental = () => {
      const [isOpen, setIsOpen] = useState(false);
        const toggleSort = () => {
          setIsOpen(!isOpen);
        };
        return (
   <main>
    <section className="body">
    <div className="tourSortMobile">
     <div className="filtering">
       <div className="location">
        <p className='sortItem'>Our Location</p>
        <iframe className="google-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3531.006345162988!2d85.29679076845517!3d27.74795029415453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb194918041995%3A0x2290f0e48f50d549!2sUjalo%20Basthi%20Lolang%20height!5e0!3m2!1sne!2snp!4v1736396520103!5m2!1sne!2snp" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
       </div>
       <div className="popular-filter">
        <p className='sortItem'>Popular Filter</p>
        <div className="popular-sort">
            <div className="legend">
                <div id="tick"></div>
                <h5>One Day Nepal Tour</h5>
            </div>
            <div className="legend">
                <div id="tick"></div>
                <h5>Short Day Nepal Tour</h5>
            </div>
            <div className="legend">
                <div id="tick"></div>
                <h5>Medium Day Nepal Tour</h5>
            </div>
            <div className="legend">
                <div id="tick"></div>
                <h5>Long Day Nepal Tour</h5>
            </div>
        </div>
       </div>
     </div>
      {/* Sort Button */}
      <button className="sortButton" onClick={toggleSort}>
        <div className="downarrow-up">
        <FontAwesomeIcon
          icon={faArrowDown}
        />
         <FontAwesomeIcon
          icon={faArrowUp}
        />
        </div>
        <span>Sort</span>

        <FontAwesomeIcon
          icon={isOpen ? faChevronUp : faChevronDown}
          className="sortIcon"
        />
      </button>

      {/* Dropdown */}
      {isOpen && (
        <div className="sortDropdown">

          <button className="sortItem">
            One Day Tour
          </button>

          <button className="sortItem">
            Short Day Tour
          </button>

          <button className="sortItem">
            Medium Day Tour
          </button>

          <button
            className="sortItem"
          >
            Long Day Tour
          </button>

        </div>
      )}

    </div>
    <div className="body-card color-none">
    <div className="talent-card">
      <div className="guide-card-two">
           <div className="profile-imgr">
          <img
            src="/img/car.webp"
            alt="profile"
          />
           </div>
           <div className="card-buttons">
           <Link to='/chineseguide' className='view-btn'> <button className="guide-btn">View Profile</button></Link>
            <button className="invite-btn"><FontAwesomeIcon icon={faVideo}></FontAwesomeIcon> See Video</button>
          </div>
      </div>
      <div className="guide-card-right">
              <div className="card-top">
                      <span className="role-badge">Professional Guide</span>
                    </div>
              <div className="profile-info">
        
          <div className="name-row">
            <h3>Ram Poudel</h3>
            <FontAwesomeIcon icon={faCheckCircle} className="verified" />
          </div>

          <p className="price">$50.00/day</p>

          <div className="locationing">
            <FontAwesomeIcon icon={faLanguage} />
            <span>Chinese, English, +1more</span>
          </div>

          {/* Tags */}
          <div className="tags">
            <span>License</span>
            <span>Review</span>
            <span>3 Years Experiences</span>
          </div>
      </div>
        </div>
      </div>
      <div className="talent-card display-gap">
      <div className="guide-card-two">
           <div className="profile-img">
          <img
            src="https://randomuser.me/api/portraits/men/32.jpg"
            alt="profile"
          />
           </div>
           <div className="card-buttons">
            <button className="view-btn">View Profile</button>
            <button className="invite-btn"><FontAwesomeIcon icon={faVideo}></FontAwesomeIcon> See Video</button>
          </div>
      </div>
      <div className="guide-card-right">
              <div className="card-top">
                      <span className="role-badge">Professional Guide</span>
                    </div>
              <div className="profile-info">
        
          <div className="name-row">
            <h3>Ram Poudel</h3>
            <FontAwesomeIcon icon={faCheckCircle} className="verified" />
          </div>

          <p className="price">$50.00/day</p>

          <div className="locationing">
            <FontAwesomeIcon icon={faLanguage} />
            <span>Chinese, English, +1more</span>
          </div>

          {/* Tags */}
          <div className="tags">
            <span>License</span>
            <span>Review</span>
            <span>3 Years Experiences</span>
          </div>
      </div>
        </div>
      </div>
    </div>
     
    </section>
    <div className="ser-block">
      <div className='ser-img'>
        <img src="/img/company/Capture.jpg" alt="error" />
      </div>
      <p className='ser-b-p'>This Service Is Not Available Right Now. Maintainence is ongoing !</p>
      <h3 className='ser-b'>See Other Available Services</h3>
      <div className='dfcv'><Link to="/nepal-tour" className='fhj'>Nepal Tour</Link></div>
     </div>
   </main>
  )}
export default Rental